export default "__VITE_ASSET__CIy_VhQO__"